export default (filtered) => {
    const hasTriggerGoal = filtered.targetTypes.find((type) => type.value === 'has_trigger_goal')

    const hasTargetLibrary = filtered.targetTypes.find((type) => type.value === 'target_library')

    const hasCommonType = filtered.targetTypes.find((type) => type.value == 'common_target')

    return {
        'tags.id': filtered.tags.map((tag) => tag.value),
        section_id: filtered.sections.map((section) => section.value),
        has_trigger_goal: hasTriggerGoal ? true : hasCommonType ? false : null,
        period_id: filtered.periods.map((period) => period.value),
        level: filtered.levels.map((level) => level.value),
        title: filtered.searchText,
        'user.name': filtered.searchName,
        'user.groups.id': filtered.occupationGroups.map((occupationGroup) => occupationGroup.value),
        target_library: hasTargetLibrary ? true : hasCommonType ? false : null,
    }
}
